/* eslint-disable no-console */
// F-16 Phase 3: bridge `register-service-worker`'s lifecycle hooks to a
// window event so App.vue can render an in-app refresh toast when a new
// build has installed in the background. Reload happens on `controllerchange`
// after the user accepts the prompt.

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("Scrawl service worker active — app served from cache.");
    },
    cached() {
      console.log("Scrawl content cached for offline use.");
    },
    updated(registration) {
      window.dispatchEvent(
        new CustomEvent("scrawl-sw-update-available", {
          detail: { waiting: registration.waiting },
        })
      );
    },
    offline() {
      console.log("No connection — Scrawl running from service worker cache.");
    },
    error(error) {
      console.error("Service worker registration error:", error);
    },
  });

  // Reload exactly once when an *updated* SW takes control, so the user sees
  // the new bundle without a manual refresh. Skip the first-ever install:
  // clientsClaim() fires controllerchange on initial activate too, and
  // reloading there double-loads the page on every first visit (and silently
  // dismissed the desktop splash, since its `seen` flag is written on mount).
  let refreshing = false;
  if ("serviceWorker" in navigator) {
    const hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hadController) return;
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }

  // App.vue dispatches this after the user accepts the toast.
  window.addEventListener("scrawl-sw-skip-waiting", (e) => {
    const waiting = e.detail && e.detail.waiting;
    if (waiting) waiting.postMessage({ type: "SKIP_WAITING" });
  });

  // Check for a new SW each time the tab becomes visible, so long-lived
  // sessions pick up deploys without waiting for the browser's ~24h heuristic.
  // registration.update() is a conditional GET — 304 when nothing changed,
  // so the cost on every foreground is negligible.
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          registration.update().catch(() => {});
        }
      });
    });
  }
}
